import React, { useEffect, useState } from 'react';
import { Box, Grid, Button, TextField, Card, CardContent, Typography, IconButton, Input, Paper, Breadcrumbs, Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Backdrop } from '@mui/material';
import { Folder as FolderIcon, FileOpen, Delete, LibraryBooks, Article } from '@mui/icons-material';
import Folder from './CommonComponents/Folder';
import Document from './CommonComponents/Document';
import AttachmentUpload from './ViewById/AttachmentUpload';

interface Document {
  title: string;
  description: string;
  file: File | null;
}

interface FolderType {
  name: string;
  documents?: Document[];
  folders?: FolderType[];
}

interface UploadedFile extends File {
    uploadedBy: string;
    uploadedAt: string;
    downloadCount: number;
    content: File;
}

const Library: React.FC = () => {
//   const [folders, setFolders] = useState<FolderType[]>([]);
//   const [newFolderName, setNewFolderName] = useState('');
//   const [newDocumentTitle, setNewDocumentTitle] = useState('');
//   const [newDocumentDescription, setNewDocumentDescription] = useState('');
//   const [selectedFolderIndex, setSelectedFolderIndex] = useState<number | null>(null);
//   const [fileInput, setFileInput] = useState<File | null>(null);

//   // Handle adding a new folder
//   const handleAddFolder = () => {
//     if (newFolderName) {
//       const newFolder: FolderType = { name: newFolderName, documents: [] };
//       setFolders([...folders, newFolder]);
//       setNewFolderName('');
//     }
//   };

//   // Handle adding a new document
//   const handleAddDocument = () => {
//     if (newDocumentTitle && newDocumentDescription) {
//       if (selectedFolderIndex !== null) {
//         const newDocument: Document = {
//           title: newDocumentTitle,
//           description: newDocumentDescription,
//           file: fileInput,
//         };

//         const updatedFolders = [...folders];
//         updatedFolders[selectedFolderIndex].documents.push(newDocument);
//         setFolders(updatedFolders);

//         // Reset form fields
//         setNewDocumentTitle('');
//         setNewDocumentDescription('');
//         setFileInput(null);
//       }
//     }
//   };

//   // Handle file upload
//   const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     if (event.target.files) {
//       setFileInput(event.target.files[0]);
//     }
//   };

//   // Handle selecting a folder to view documents
//   const handleFolderClick = (index: number) => {
//     setSelectedFolderIndex(index);
//   };

//   // Handle deleting a document
//   const handleDeleteDocument = (folderIndex: number, documentIndex: number) => {
//     const updatedFolders = [...folders];
//     updatedFolders[folderIndex].documents.splice(documentIndex, 1);
//     setFolders(updatedFolders);
//   };

//   return (
//     <Box sx={{ padding: 4 }}>
//       <Grid container spacing={3}>
//         {/* Folder Input Section */}
//         <Grid item xs={12}>
//           <TextField
//             label="New Folder Name"
//             variant="outlined"
//             value={newFolderName}
//             onChange={(e) => setNewFolderName(e.target.value)}
//             sx={{ marginRight: 2 }}
//           />
//           <Button variant="contained" color="primary" onClick={handleAddFolder}>
//             Add Folder
//           </Button>
//         </Grid>

//         {/* Folders Display */}
//         <Grid item xs={12}>
//           <Box display="flex" flexWrap="wrap">
//             {folders.map((folder, folderIndex) => (
//               <Card sx={{ maxWidth: 200, margin: 2 }} key={folderIndex} onClick={() => handleFolderClick(folderIndex)}>
//                 <CardContent>
//                   <Box display="flex" alignItems="center">
//                     <Folder />
//                     <Typography variant="h6" sx={{ marginLeft: 1 }}>
//                       {folder.name}
//                     </Typography>
//                   </Box>
//                 </CardContent>
//               </Card>
//             ))}
//           </Box>
//         </Grid>

//         {/* Document Input Section (Visible only when a folder is selected) */}
//         {selectedFolderIndex !== null && (
//           <Grid item xs={12}>
//             <TextField
//               label="New Document Title"
//               variant="outlined"
//               value={newDocumentTitle}
//               onChange={(e) => setNewDocumentTitle(e.target.value)}
//               sx={{ marginRight: 2 }}
//             />
//             <TextField
//               label="Document Description"
//               variant="outlined"
//               value={newDocumentDescription}
//               onChange={(e) => setNewDocumentDescription(e.target.value)}
//               sx={{ marginRight: 2 }}
//             />
//             <Input
//               type="file"
//               onChange={handleFileChange}
//               sx={{ marginRight: 2 }}
//             />
//             <Button variant="contained" color="primary" onClick={handleAddDocument}>
//               Add Document
//             </Button>
//           </Grid>
//         )}

//         {/* Documents Display (Visible only when a folder is selected) */}
//         {selectedFolderIndex !== null && (
//           <Grid item xs={12}>
//             <Box display="flex" flexWrap="wrap">
//               {folders[selectedFolderIndex].documents.map((doc, docIndex) => (
//                 <Card sx={{ maxWidth: 300, margin: 2 }} key={docIndex}>
//                   <CardContent>
//                     <Box display="flex" alignItems="center">
//                       <FileOpen />
//                       <Typography variant="h6" sx={{ marginLeft: 1 }}>
//                         {doc.title}
//                       </Typography>
//                     </Box>
//                     <Typography variant="body2" sx={{ marginTop: 1 }}>
//                       {doc.description}
//                     </Typography>
//                     {doc.file && (
//                       <Typography variant="body2" sx={{ marginTop: 1 }}>
//                         <strong>File:</strong> {doc.file.name}
//                       </Typography>
//                     )}
//                     <IconButton onClick={() => handleDeleteDocument(selectedFolderIndex, docIndex)}>
//                       <Delete />
//                     </IconButton>
//                   </CardContent>
//                 </Card>
//               ))}
//             </Box>
//           </Grid>
//         )}
//       </Grid>
//     </Box>
//   );

const [path, setPath] = useState<string[]>(['Library']);
const currentDirectory: FolderType = {
    name: 'Alpha Bet',
    folders: [
        {
            name: 'Folder 1',
            folders: [
                {
                    name: 'Folder 1.1',
                    folders: [
                        {
                            name: 'Folder 1.1.1',
                            folders: [
                                {
                                    name: 'Folder 1.1.1.1',
                                    documents: [
                                        {
                                            title: 'Document 1 1 1',
                                            description: 'Description 1 1 1',
                                            file: null
                                        },
                                        {
                                            title: 'Document 2 2 2',
                                            description: 'Description 2 2 2',
                                            file: null
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    documents: [
                        {
                            title: 'Document 1',
                            description: 'Description 1',
                            file: null
                        },
                        {
                            title: 'Document 2',
                            description: 'Description 2',
                            file: null
                        }
                    ]
                }
            ],
            documents: [
                {
                    title: 'Document 1',
                    description: 'Description 1',
                    file: null
                },
                {
                    title: 'Document 2',
                    description: 'Description 2',
                    file: null
                }
            ]
        },
        {
            name: 'Folder 2',
            folders: [
                {
                    name: 'Folder 2.1',
                    folders: [
                        {
                            name: 'Folder 2.1.1'
                        }
                    ]
                }
            ]
        }
    ],
    documents: [
        {
            title: 'Document 1',
            description: 'Description 1',
            file: null
        },
        {
            title: 'Document 2',
            description: 'Description 2',
            file: null
        }
    ]
};

const [activeFolder, setActiveFolder] = useState<FolderType>(currentDirectory);
const [open, setOpen] = useState(false);
const [newFolderName, setNewFolderName] = useState('');
const [selectedFiles, setSelectedFiles] = useState<UploadedFile[]>([]);
const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
const [isDragging, setIsDragging] = useState(false);

useEffect(() => {
    setActiveFolder(currentDirectory);
}, []);

useEffect(() => {
    if (path.length === 1) {
        setActiveFolder(currentDirectory);
    }
    else {
        const newActiveFolder = path.reduce((acc, folderName) => {
            return acc.folders?.find(folder => folder.name === folderName) || acc;
        }, currentDirectory);
        setActiveFolder(newActiveFolder);
    }
}, [path]);

    const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files) {
            const filesArray = Array.from(files).map((file) => {
                const uploadedFile: UploadedFile = {
                    ...file,
                    uploadedBy: "user.id",
                    uploadedAt: new Date().toISOString(),
                    downloadCount: 0,
                    content: file,
                };
                return uploadedFile;
            });

            setSelectedFiles((prevFiles) => [...prevFiles, ...filesArray]);
        }
    };


const getBreadCrumb = () => {
    return (
        <Breadcrumbs separator="›" aria-label="breadcrumb">
            {path.map((folder, index) => (
                <Chip
                    onClick={() => {
                        const newPath = path.slice(0, index + 1);
                        setPath(newPath);
                    }}
                    key={index}
                    label={folder}
                    sx={{
                    position: 'relative',
                    paddingRight: '32px',
                    borderRadius: '4px',
                    backgroundColor: 'primary.main',
                    color: 'white',
                    '&:hover': {
                        backgroundColor: 'primary.main',
                    },
                    '&:after': {
                        content: '""',
                        position: 'absolute',
                        right: '-12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: 0,
                        height: 0.1,
                        borderTop: '12px solid transparent',
                        borderBottom: '12px solid transparent',
                        borderLeft: '12px solid',
                        borderLeftColor: 'primary.main',
                    },
                }}/>
            ))}
        </Breadcrumbs>
    );
}

const folderOnClickFunc = (folderName: string) => {
    const newPath = [...path, folderName];
    setPath(newPath);
}

const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

const handleCreate = () => {
    console.log('Create ' + newFolderName);
}

const addFolderDialog = () => {
    return (
        <Dialog open={open} onClose={handleClose}>
        <DialogTitle>New Folder</DialogTitle>
        <DialogContent>
            <TextField
                sx={{width: 350}}
                autoFocus
                margin="dense"
                id="name"
                label="Folder Name"
                onChange={(e) => setNewFolderName(e.target.value)}
                type="text"
                fullWidth
            />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleCreate} autoFocus>Create</Button>
        </DialogActions>
      </Dialog>
    );
}


useEffect(() => {
    console.log(selectedFiles);
}
, [selectedFiles]);

return (
    <>
        <Paper onDragOver={(e) => {e.preventDefault(); setIsDragging(true);}} onDragLeave={() => setIsDragging(false)}
            onDrop={(e) => {
                e.preventDefault();
                setIsDragging(false);
                const files = Array.from(e.dataTransfer.files);
                const uploadedFiles = files.map((file) => ({
                    ...file,
                    uploadedBy: "user.id",
                    uploadedAt: new Date().toISOString(),
                    downloadCount: 0,
                    content: file,
                }));
                setSelectedFiles((prevFiles) => [...prevFiles, ...uploadedFiles]);
            }} elevation={5} 
            sx={{mb: 2, padding: 3, borderRadius: 3
             }}>
                <Backdrop open={isDragging} sx={{zIndex: 1, color: '#fff', backgroundColor: 'rgba(0, 0, 0, 0.5)'}} />
            <Paper elevation={3} sx={{mb: 2, padding: 2, borderRadius: 3, display: 'flex', justifyContent: 'space-between'}}>
                <Box color='primary.main' sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', }}>
                    <LibraryBooks sx={{mr:1, height: 40, width: 40}} />
                    <Typography variant="h5">Library</Typography>
                </Box>
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '35%'}}>
                    <Button variant="contained" color="primary" onClick={() => (document.querySelector('input[type="file"]') as HTMLInputElement)?.click()}>
                        <Article sx={{mr: 1}} /> Add File
                    </Button>
                    <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
                        <FolderIcon sx={{mr: 1}} />
                        Add Folder
                    </Button>
                </Box>
            </Paper>
            {getBreadCrumb()}
            {addFolderDialog()}
            {activeFolder.folders?.map((folder, index) => (
                <Folder onClickFunc={folderOnClickFunc} key={index} name={folder.name} />
            ))}
            {activeFolder.documents?.map((document, index) => (
                <Document key={index} title={document.title} description={document.description} file={document.file} />
            ))}
            {uploadedFiles.length !== 0 && uploadedFiles.map((file) => <Typography key={file.name}>{file.name}</Typography>)}
            <input
                    type="file"
                    multiple
                    hidden
                    onChange={handleFileSelect}
                />
        </Paper>
    </>
)

};

export default Library;
